import request from '@/utils/request'
import {
  MyEquipmentItem,
  AuthClientListRequest,
  AuthClientListResponse,
  ProductSelectionListResponse,
  ProductSelectionDetailResponse,
  RequestSendVerifyCodeParamsType,
  AgriculturalLoanApplyRequest,
  AgriculturalLoanOrderListResponse,
  AgriculturalLoanOrderDetail,
} from '@/types/agricultura-loan'
import { XssCommonPageListQuery } from '@/types/public'

// 获取用户设备数据
export function getClientDeviceList(): Promise<MyEquipmentItem[]> {
  return request.get('/api-new-crm/app/new_agricultural_loan/my_equipment_list')
}

// 获取选配列表, 列表是分页结构，默认请求多个一次性加载完
export function getProductSelectionList(): Promise<ProductSelectionListResponse> {
  return request.get('/api-new-crm/app/new_agricultural_loan/product_selection_list', {
    params: {
      page: 1,
      per_page: 100,
    },
  })
}

// 获取选配详情
export function getProductSelectionDetail(guid: string): Promise<ProductSelectionDetailResponse> {
  return request.get('/api-new-crm/app/new_agricultural_loan/product_selection_detail?guid=' + guid)
}

// 获取授权客户列表
export function getAuthClientList(params: AuthClientListRequest): Promise<AuthClientListResponse> {
  return request.get('/api-new-crm/app/new_agricultural_loan/auth_client_list', { params })
}

// 查询序列号信息
export function requestAddUnActivetedDevice(param: {
  serial_number: string
  material_code: string
}): Promise<{
  name: string
}> {
  return request.post('/api-new-crm/app/new_agricultural_loan/add_inactive_device', param)
}

// 获取验证码
export function requestSendVerifyCode(params: RequestSendVerifyCodeParamsType): Promise<{
  message_guid: string
}> {
  return request.post('/api-new-crm/app/new_agricultural_loan/send_code', params)
}

// 提交申请
export function requestAgriculturaLoanApply(params: AgriculturalLoanApplyRequest): Promise<{
  jump_url: string
}> {
  return request.post('/api-new-crm/app/new_agricultural_loan/apply', params)
}

// 获取贷款列表
export function requestAgriculturaLoanApplyList(
  params: XssCommonPageListQuery
): Promise<AgriculturalLoanOrderListResponse> {
  return request.get('/api-new-crm/app/new_agricultural_loan/order_list', { params })
}

// 获取贷款详情
export function getAgriculturaLoanApplyDetail(
  number: string
): Promise<AgriculturalLoanOrderDetail> {
  return request.get('/api-new-crm/app/new_agricultural_loan/order_detail?number=' + number)
}

// 校验是否满足贷款资质
export function requestCheckQualification(): Promise<{
  is_qualified: boolean // 是否可申请
  message: string // 不可申请原因
}> {
  return request.post('/api-new-crm/app/new_agricultural_loan/check_qualification')
}

// 撤销申请接口
export function requestCancelOrder(params: { number: string }): Promise<void> {
  return request.post('/api-new-crm/app/new_agricultural_loan/cancel_order', params)
}

// 获取兴邦小程序地址
export function getXingbangWxMiniProgramUrlScheme(): Promise<string> {
  return request.get('/api/external/xingbang/mini_program_redirect_url')
}
